module.exports = __webpack_public_path__ + "img/banner.ed64ad00.jpg";